import React from "react";
import { Handshake } from "lucide-react";

export function HandshakeIcon({ className = "w-5 h-5", color = "#00F0FF", testId, title }) {
  return (
    <Handshake data-testid={testId} aria-label={title || "Handshakes"} strokeWidth={2.4}
               className={`inline-block shrink-0 ${className}`}
               style={{ color, filter: `drop-shadow(0 0 3px ${color}) drop-shadow(0 0 7px ${color}88)` }}>
      {title && <title>{title}</title>}
    </Handshake>
  );
}
